import type { TailorStage } from "@/lib/applications";
import type { Posting } from "@/lib/api/catalogue";
import type { FitView, WrittenResume } from "@/lib/posting";
import FitCard from "./FitCard";
import { ApplyOnTheirSite } from "./PostingButtons";
import PostingText from "./PostingText";
import TailorCard from "./TailorCard";
import VisitorFit from "./VisitorFit";
import { SectionCard } from "./parts";

/**
 * The main column before applying: the fit, the tailor card with what it wrote, the text, and
 * Apply on their site again at its end while the posting is open.
 */
export default function BeforeSending({
    posting,
    member,
    atMatch,
    fit,
    fitLoading,
    tailor,
    written,
    onAddResume,
}: {
    posting: Posting;
    member: boolean;
    /** Whether there is an application, so the fit is the one at the match. */
    atMatch: boolean;
    fit: FitView | null;
    fitLoading: boolean;
    /** Tailor my resume and its terms, or null when it is not offered. */
    tailor: {
        stage: TailorStage;
        model: string;
        cost: string | null;
        resumeId?: string | null;
        failed?: boolean;
    } | null;
    written: WrittenResume[];
    onAddResume: () => void;
}) {
    return (
        <>
            {!member ? (
                <VisitorFit
                    postingId={posting.posting_id}
                    job={posting}
                    onAddResume={onAddResume}
                />
            ) : fitLoading ? (
                <SectionCard title="Fit">
                    <p className="m-0 mt-3 text-ui text-fg-muted">Scoring the fit…</p>
                </SectionCard>
            ) : (
                <FitCard fit={fit} atMatch={atMatch} />
            )}
            <TailorCard
                postingId={posting.posting_id}
                job={posting}
                tailor={tailor}
                written={written}
            />
            <PostingText
                description={posting.description}
                foot={!posting.closed_at && <ApplyOnTheirSite posting={posting} section="foot" />}
            />
        </>
    );
}
